import React from 'react'

export function TrashIcon(props: React.SVGProps<SVGSVGElement>) {
  const [clipId] = React.useState(() => `clip0_${Date.now()}`)
  return (
    <svg
      width='24'
      height='25'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d='M16.4521 9L15.667 17.6357C15.5968 18.4083 14.9495 18.9999 14.1738 19H9.82617C9.05048 18.9999 8.40324 18.4083 8.33301 17.6357L7.54785 9H16.4521Z'
          stroke='currentColor'
        />
        <path d='M11 12L11 16' stroke='currentColor' strokeLinecap='round' />
        <path d='M13 12L13 16' stroke='currentColor' strokeLinecap='round' />
        <path d='M17 7L7 7' stroke='currentColor' strokeLinecap='round' />
        <path
          d='M10 6H14C14.2761 6 14.5 6.22386 14.5 6.5V7H9.5V6.5C9.5 6.22386 9.72386 6 10 6Z'
          stroke='currentColor'
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width='24' height='24' fill='white' transform='translate(0 0.5)' />
        </clipPath>
      </defs>
    </svg>
  )
}
